import { Component, Input, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { LucideAngularModule } from 'lucide-angular';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth-service/auth.service';
import {
  CurrentUserInfo,
  CurrentUserService,
} from '../../../services/current-user.service';

@Component({
  selector: 'app-sidebar-footer',
  standalone: true,
  imports: [
    CommonModule,
    TooltipModule,
    PopoverModule,
    AvatarModule,
    LucideAngularModule,
    TranslocoModule,
  ],
  templateUrl: './sidebar-footer.component.html',
})
export class SidebarFooterComponent {
  @Input() isCollapsed = false;
  // @Input() user: CurrentUserInfo | null = null;
  user: CurrentUserInfo | null = null;

  private router = inject(Router);
  private authService = inject(AuthService);
  private currentUserService = inject(CurrentUserService);
  private translocoService = inject(TranslocoService);

  constructor() {
    effect(() => {
      this.user = this.currentUserService.currentUser();
    });
  }

  onAccountClick(): void {
    this.router.navigate(['/home/account']);
  }

  onNavigate(section: 'profile' | 'company' | 'users' | 'billing'): void {
    this.router.navigate(['/home/account', section]);
  }

  formatMemberSince(dateString: string): string {
    const date = new Date(dateString);
    const lang = this.translocoService.getActiveLang();
    return date.toLocaleDateString(lang, { month: 'long', year: 'numeric' });
  }

  translateRole(role: string): string {
    const roleKeys: Record<string, string> = {
      admin: 'accountMenu.usersManagement.roleAdmin',
      superAdmin: 'accountMenu.usersManagement.roleSuperAdmin',
      user: 'accountMenu.usersManagement.roleUser',
    };
    const key = roleKeys[role];
    return key ? this.translocoService.translate(key) : role;
  }

  onLogoutClick(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/auth/login']);
      },
      error: (err: Error) => {
        console.error('Logout error', err);
      },
    });
  }
}
